<template>
    <div>
        <button type="button" class="btn btn-secondary" @click="processAssets">Process Assets</button>
       <div class="spinner" v-if="processing">
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
          <div class="rect5"></div>
        </div>
        <small v-if="processing && progress_detail" class="text-muted d-block mt-1">{{ progress_detail }}</small>
        <div v-if="error_message">
            <p>{{ error_message }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            campaign: {
                type: Object
            }
        },
        data() {
            return {
                processing: false,
                error_message: false,
                progress_detail: ''
            }
        },
        created() {
            Echo.private('campaign-status').listen('.crawler-status', (e) => {
                if (e && this.campaign.id === e.campaign_id) {
                    if (e.status === 'active' || e.status === 'completed_with_errors') {
                        this.processing = false;
                        window.location.reload();
                    }
                    if (e.progress) {
                        this.progress_detail = e.progress.engine + ': ' + e.progress.keyword
                            + ' (' + e.progress.keywords_completed + '/' + e.progress.keywords_total + ')';
                    }
                }
            });
        },
        methods: {
            processAssets(event) {
                event.preventDefault();
                if (!this.processing) {
                    this.processing = true;
                    axios.put('/api/search_results/' + this.campaign.id + '/process')
                    .then((response) => {})
                    .catch((error) => {
                        console.log(error.response);
                        this.processing = false;
                        this.error_message = "Asset processing failed w/ error: " + error.response.data.message;
                    });
                }
            }
        }
    }
</script>
